import { render } from "./HamCheshmi.vue?vue&type=template&id=632c2831&scoped=true"
import script from "./HamCheshmi.vue?vue&type=script&lang=js"
export * from "./HamCheshmi.vue?vue&type=script&lang=js"

import "./HamCheshmi.vue?vue&type=style&index=0&id=632c2831&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632c2831"]])

export default __exports__